module.exports = __webpack_public_path__ + "static/media/acheiveImage.377ace2c.svg";